function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewWorkspace = function SvgNewWorkspace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11 0 20 9 20 20s-9 20-20 20S0 31 0 20 9 0 20 0z",
    style: {
      fill: "#03d47c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12.8c0-1 .8-1.8 1.8-1.8h10.5c1 0 1.8.8 1.8 1.8v14.5c0 1-.8 1.8-1.8 1.8H22v-3.2c0-.4-.4-.8-.8-.8h-2.4c-.4 0-.8.4-.8.8V29h-3.2c-1 0-1.8-.8-1.8-1.8V12.8zm3.9.2c-.6 0-1 .4-1 1s.4 1 1 1h6.2c.6 0 1-.4 1-1s-.4-1-1-1h-6.2zm-1 5c0-.6.4-1 1-1h6.2c.6 0 1 .4 1 1s-.4 1-1 1h-6.2c-.6 0-1-.4-1-1zm1 3c-.6 0-1 .4-1 1s.4 1 1 1h6.2c.6 0 1-.4 1-1s-.4-1-1-1h-6.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 5.8c0-.1-.1-.1 0 0-.6-1-2-1-2.6 0h0l-.9 1.7-2.1.3h0c-1.1.1-1.8 1.5-.8 2.4h0l1.5 1.3-.3 1.8v0c-.1.6.2 1.1.6 1.4.4.3 1 .3 1.5.1 0 0 0 0 0 0l1.9-.9 1.9.9s0 0 0 0 0 0 0 0c.5.2 1.1.2 1.5-.1.4-.3.7-.8.6-1.4v0l-.3-1.8 1.5-1.3h0c1-.9.3-2.3-.8-2.4h0l-2.1-.3-1.1-1.7z",
    style: {
      fill: "#fed607",
      stroke: "#03d47c",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
};
export default SvgNewWorkspace;